<!----
    Author: hjlee
    Description:
        XDATA 수정 컨트롤
---->
<template>
  <div class="update-row-control-area">
    <input style="display:none" type="text" name="faketextremembered" autofocus="true">
    <input style="display:none" type="password" name="fakepasswordremembered">
    <div class="rows">
      <div v-for="(updateColumn, index) in updateColumns" :key="index" :class="getCssClasses(updateColumn.inputControl)">
        <div v-if="(!step || step === updateColumn.step) && updateColumn.inputControl && updateColumn.inputControl.type !== 'none' && (!onlyRequiredFields || updateColumn.inputControl.required)" class="form-group">
          <div class="controls">
            <input style="display:none" type="text" name="faketextremembered">
            <input style="display:none" type="password" name="fakepasswordremembered">
            <input-control
              :ref="'updateForm.' + updateColumn.key"
              v-model="userUpdateRow[updateColumn.key]"
              :name="updateColumn.key.toSnakeCase()"
              :file-info="updateColumn.file"
              :options="getSelectOptions(updateColumn)"
              :title="updateColumn.label"
              :table-name="item"
              :purpose="purpose"
              :async-search-url="updateColumn.inputControl.asyncSearchUrl"
              :multiple="updateColumn.inputControl.multiple"
              :checkbox-label="updateColumn.inputControl.checkboxLabel"
              :fetching-children-url="updateColumn.inputControl.fetchingChildrenUrl"
              :get-initial-value-url="updateColumn.inputControl.getInitialValueUrl"
              :type="updateColumn.inputControl.type"
              :camera-button-image="cameraButtonImage"
              :show-image-viewer="showImageViewer"
              :cover-image="coverImage"
              :use-middle-name="updateColumn.inputControl.useMiddleName"
              :type-code-field-name="updateColumn.inputControl.typeCodeFieldName"
              :placeholder="updateColumn.inputControl.placeholderTextCode?$t(updateColumn.inputControl.placeholderTextCode):undefined"
              :orderable="updateColumn.inputControl.orderable"
              :rules="(dontCheckAuthor||hasAuthority('update_' + item))?getValidationRulesObject(updateColumn, module, item, userUpdateRow):{}"
              :required="updateColumn.inputControl.required"
              :notifications="getNotifications(updateColumn.inputControl, false)"
              :prefix="getPrefix(updateColumn.inputControl, userUpdateRow)"
              :postfix="getPostfix(updateColumn.inputControl, userUpdateRow)"
              :readonly="updateColumn.update && updateColumn.update.readonly"
              :visible-type="updateColumn.inputControl.visibleType"
              :visible-by="updateColumn.inputControl.visibleBy"
              :visible-data="userUpdateRow"
              :with-fields="getWithFields(updateColumn.inputControl)"
              @forceUpdate="onForceUpdate"
            />
            <input-control
              v-if="updateColumn.inputControl.type === 'password'"
              :ref="'updateForm.' + updateColumn.key + 'Confirm'"
              v-model="userUpdateRow[updateColumn.key + 'Confirm']"
              name="user_pwd_confirm"
              :type="updateColumn.inputControl.type"
              :type-code-field-name="updateColumn.inputControl.typeCodeFieldName"
              :placeholder="updateColumn.inputControl.placeholderTextCode?$t(updateColumn.inputControl.placeholderTextCode):undefined"
              :orderable="updateColumn.inputControl.orderable"
              :rules="'password_confirm:' + userUpdateRow[updateColumn.key]"
              :required="updateColumn.inputControl.required"
              :visible-type="updateColumn.inputControl.visibleType"
              :visible-by="updateColumn.inputControl.visibleBy"
              :visible-data="userUpdateRow"
            />
          </div>
          <div v-if="updateColumn.clear" class="clear" />
        </div>
      </div>
      <div class="clear" />
      <additional-field-control
        v-if="infos && infos.additionalFieldInfoData"
        ref="updateForm.additionalFieldControl"
        v-model="userUpdateRow"
        :table-name="item"
        :info-data="infos.additionalFieldInfoData"
        :only-required-fields="onlyRequiredFields"
        class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12"
        @forceUpdate="onForceUpdate"
      />
      <div class="clear" />
    </div>
    <b-modal
      id="update-confirm-modal"
      ref="updateConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="update"
    >
      <p class="my-4" v-html="$t('common.modal.text.update_confirm')" />
    </b-modal>
    <b-modal
      id="cancel-update-confirm-modal"
      ref="exitUpdateConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="exitUpdate"
    >
      <p class="my-4" v-html="$t('common.modal.text.updated_confirm')" />
    </b-modal>
    <div v-if="showActionControls" class="form-actions">
      <button v-if="nextStep" class="btn btn-primary" type="button" :disabled="!contentsValidated('updateForm')" @click="next">
        {{ nextButtonName?nextButtonName:$t('common.button.next') }}
      </button>
      <button v-else-if="showUpdateButton" class="btn btn-primary" type="submit" :disabled="!contentsValidated('updateForm')" @click="updateConfirm">
        {{ saveButtonName?saveButtonName:$t('common.button.save') }}
      </button>
      <button v-if="showCancelButton" class="btn btn-secondary" type="button" @click="cancelUpdate">
        {{ $t('common.button.cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    cameraButtonImage: {
      type: String,
      default: undefined
    },
    showImageViewer: {
      type: Boolean,
      default: true
    },
    coverImage: {
      type: Boolean,
      default: true
    },
    loadUpdateUrl: {
      type: String,
      required: true
    },
    showActionControls: {
      type: Boolean,
      default: true
    },
    updateUrl: {
      type: String,
      required: true
    },
    purpose: {
      type: String,
      default: 'general'
    },
    module: {
      type: String,
      required: true
    },
    item: {
      type: String,
      required: true
    },
    showUpdateButton: {
      type: Boolean,
      default: true
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    onlyRequiredFields: {
      type: Boolean,
      default: false
    },
    dontCheckAuthor: {
      type: Boolean,
      default: false
    },
    step: {
      type: String,
      default: ''
    },
    nextStep: {
      type: String,
      default: ''
    },
    saveButtonName: {
      type: String,
      default: ''
    },
    nextButtonName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      infos: {},
      userUpdateRow: {},
      updateColumns: []
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    loadUpdateRow() {
      return this.$axios.$get(this.loadUpdateUrl).then(response => {
        if (response.resultCode === 'success') {
          return response.data
        }
      })
    },
    next() {
      const param = {
        event: this.nextStep,
        row: this.userUpdateRow
      }
      this.$emit('next-step', param)
    },
    async load() {
      const userUpdate = await this.loadUpdateRow()
      if (userUpdate) {
        this.loadUpdate(userUpdate)
        this.infos = userUpdate.infos
      }
    },
    updateConfirm: function() {
      window._eventHub.$emit('showLoading')
      const userUpdateRow = window.copyObject(this.userUpdateRow)
      // 사전 처리
      for (let i = this.updateColumns.length - 1; i >= 0; i--) {
        if (this.updateColumns[i].inputControl.type === 'password') {
          if (
            userUpdateRow[this.updateColumns[i].key] !==
            userUpdateRow[this.updateColumns[i].key + 'Confirm']
          ) {
            this.$toast.error(this.$t('validation.message.password_confirm'))
            return
          }
        }
        if (
          this.updateColumns[i].inputControl.type === 'date' ||
          this.updateColumns[i].inputControl.type === 'datetime'
        ) {
          const key = this.updateColumns[i].key
          if (userUpdateRow[this.updateColumns[i].key]) {
            let format
            if (this.updateColumns[i].inputControl.type === 'date') {
              format = this.$t('common.format.date')
            } else {
              format = this.$t('common.format.datetime')
            }
            if (userUpdateRow[this.updateColumns[i].key]) {
              userUpdateRow[key] = moment(
                userUpdateRow[this.updateColumns[i].key],
                format
              )
                .toDate()
                .getTime()
            } else {
              userUpdateRow[key] = null
            }
          } else {
            delete userUpdateRow[key]
          }
        }
      }
      if (!window.isObjectEquals(userUpdateRow, this.initialUpdateRow)) {
        this.showModal('updateConfirmModalRef')
      } else {
        this.exitUpdate()
        window._eventHub.$emit('hideLoading')
      }
    },
    update: function() {
      this.isBusy = true

      const userUpdateRow = window.copyObject(this.userUpdateRow)
      // 사전 처리
      for (let i = this.updateColumns.length - 1; i >= 0; i--) {
        if (this.updateColumns[i].inputControl.type === 'multiselect') {
          const key = this.updateColumns[i].key
          const values = []
          for (let j = 0; j < userUpdateRow[key].length; j++) {
            values.push(userUpdateRow[key][j].value)
          }
          userUpdateRow[key] = values
        }
      }
      let updateUrl = this.updateUrl

      if (updateUrl.indexOf('?') >= 0) {
        updateUrl += '&'
      } else {
        updateUrl += '?'
      }
      updateUrl += this.getMenuAliasQuery()
      this.$axios
        .$put(updateUrl, userUpdateRow)
        .then(response => {
          this.isBusy = false
          if (response.resultCode === 'success') {
            const data = response.data
            if (data && data.charsts) {
              for (let i = 0; i < data.charsts.length; i++) {
                let locale = data.charsts[i].locale
                if (locale && locale.locale) {
                  locale = locale.locale
                }
                this.setI18nMessage(
                  locale,
                  data.charsts[i].code,
                  data.charsts[i].charst
                )
              }
            }
            this.$toast.info(this.$t(response.message, response.params))
            this.$emit('updated', data)
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    cancelUpdate() {
      window._eventHub.$emit('showLoading')

      const userUpdateRow = window.copyObject(this.userUpdateRow)
      // 사전 처리
      for (let i = this.updateColumns.length - 1; i >= 0; i--) {
        if (
          this.updateColumns[i].inputControl.type === 'date' ||
          this.updateColumns[i].inputControl.type === 'datetime'
        ) {
          const key = this.updateColumns[i].key
          if (userUpdateRow[this.updateColumns[i].key]) {
            let format
            if (this.updateColumns[i].inputControl.type === 'date') {
              format = this.$t('common.format.date')
            } else {
              format = this.$t('common.format.datetime')
            }
            if (userUpdateRow[this.updateColumns[i].key]) {
              userUpdateRow[key] = moment(
                userUpdateRow[this.updateColumns[i].key],
                format
              )
                .toDate()
                .getTime()
            } else {
              userUpdateRow[key] = null
            }
          } else {
            delete userUpdateRow[key]
          }
        }
      }
      if (!window.isObjectEquals(userUpdateRow, this.initialUpdateRow)) {
        this.showModal('exitUpdateConfirmModalRef')
      } else {
        this.exitUpdate()
      }
      window._eventHub.$emit('hideLoading')
    },
    exitUpdate() {
      this.$emit('cancel')
    },
    forceUpdate() {
      this.$forceUpdate()
    }
  }
}
</script>
